import { render, staticRenderFns } from "./ComplaintInfo.vue?vue&type=template&id=6df15cdb&"
import script from "./ComplaintInfo.vue?vue&type=script&lang=js&"
export * from "./ComplaintInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports